(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-announcement"] && !Shopify.designMode) return;
  try {
    
  class FFAnnouncement extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.ff-announcement__item')];
      if (this.dataset.rotate !== 'true' || this.items.length < 2) return;
      const interval = Math.max(2, Number(this.dataset.interval) || 5) * 1000;
      this.index = 0;
      this.timer = setInterval(() => this.advance(), interval);
      this.addEventListener('pointerenter', () => clearInterval(this.timer));
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    advance() {
      if (document.hidden) return;
      this.items[this.index].hidden = true;
      this.index = (this.index + 1) % this.items.length;
      this.items[this.index].hidden = false;
    }
  }

  if (!customElements.get('ff-announcement')) customElements.define('ff-announcement', FFAnnouncement);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-blog-grid"]) return;
  try {
    
  class FFBlogGrid extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.sectionId = this.dataset.sectionId;
      this.addEventListener('click', (event) => this.onClick(event));
      this.onPop = (event) => this.restore(event);
      window.addEventListener('popstate', this.onPop);
      this.applyCachedCounts();
      this.whenIdle(() => this.warmCounts());
    }

    whenIdle(fn) {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(fn, { timeout: 3000 });
      } else {
        setTimeout(fn, 1200);
      }
    }

    disconnectedCallback() {
      if (this.onPop) window.removeEventListener('popstate', this.onPop);
    }

    get grid() { return this.querySelector('[data-ff-blog-grid]'); }
    get moreWrap() { return this.querySelector('[data-ff-blog-more]'); }
    get view() { return this.querySelector('[data-ff-blog-view]'); }

    plainClick(event) {
      return !(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0);
    }

    onClick(event) {
      if (!this.plainClick(event)) return;

      const more = event.target.closest('[data-ff-blog-more] a.ff-button');
      if (more && this.contains(more)) {
        if (more.getAttribute('aria-busy') === 'true') return;
        event.preventDefault();
        this.loadMore(more);
        return;
      }

      const chip = event.target.closest('.ff-blog-grid__chip');
      if (chip && this.contains(chip)) {
        if (chip.classList.contains('ff-blog-grid__chip--active')) {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        this.filter(chip.getAttribute('href'), true);
      }
    }

    sectionUrl(href) {
      const url = new URL(href, window.location.origin);
      if (this.sectionId) url.searchParams.set('section_id', this.sectionId);
      return url.toString();
    }

    async fetchSection(href) {
      const response = await fetch(this.sectionUrl(href), { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const root = doc.querySelector('ff-blog-grid');
      if (!root) throw new Error('no section root in response');
      return root;
    }

    scroller() {
      let node = this.parentElement;
      while (node && node !== document.body) {
        const style = getComputedStyle(node);
        if (node.scrollHeight > node.clientHeight && /auto|scroll/.test(style.overflowY)) return node;
        node = node.parentElement;
      }
      return document.scrollingElement || document.documentElement;
    }

    async filter(href, push) {
      if (!href || this.busy) return;
      this.busy = true;
      this.setAttribute('aria-busy', 'true');

      const nav = this.querySelector('.ff-blog-grid__filters');
      const anchorTop = nav ? nav.getBoundingClientRect().top : null;

      try {
        const root = await this.fetchSection(href);

        Array.from(root.attributes).forEach((attr) => {
          if (attr.name.startsWith('data-') && attr.name !== 'data-section-id') {
            this.setAttribute(attr.name, attr.value);
          }
        });
        this.innerHTML = root.innerHTML;

        if (push) {
          history.pushState({ ffBlogGrid: this.sectionId, href: href }, '', href);
        }

        const nextNav = this.querySelector('.ff-blog-grid__filters');
        if (anchorTop !== null && nextNav) {
          const delta = nextNav.getBoundingClientRect().top - anchorTop;
          if (Math.abs(delta) > 1) {
            const scroller = this.scroller();
            scroller.scrollTop = Math.max(0, scroller.scrollTop + delta);
          }
        }

        this.announce();
        this.applyCachedCounts();
        this.whenIdle(() => this.warmCounts());
      } catch (error) {
        console.error('[ff-blog-grid] filter failed, navigating instead', error);
        window.location.href = href;
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
      }
    }

    restore(event) {
      const state = event.state;
      if (!state || state.ffBlogGrid !== this.sectionId) return;
      this.filter(state.href || window.location.pathname, false);
    }

    announce() {
      const grid = this.grid;
      let live = this.querySelector('[data-ff-blog-live]');
      if (!live) {
        live = document.createElement('p');
        live.setAttribute('data-ff-blog-live', '');
        live.className = 'ff-blog-grid__heading--hidden';
        live.setAttribute('role', 'status');
        live.setAttribute('aria-live', 'polite');
        this.appendChild(live);
      }
      const count = grid ? grid.children.length : 0;
      live.textContent = count === 1 ? '1 article shown' : count + ' articles shown';
    }

    async loadMore(button) {
      const href = button.getAttribute('href');
      const grid = this.grid;
      if (!href || !grid) return;
      button.setAttribute('aria-busy', 'true');

      try {
        const root = await this.fetchSection(href);
        const nextGrid = root.querySelector('[data-ff-blog-grid]');
        if (!nextGrid) throw new Error('no grid in response');

        const cards = Array.from(nextGrid.children);
        if (!cards.length) throw new Error('no cards in response');
        cards.forEach((card) => grid.appendChild(card));

        const nextHref = root.querySelector('[data-ff-blog-more] a.ff-button');
        if (nextHref && nextHref.getAttribute('href')) {
          button.setAttribute('href', nextHref.getAttribute('href'));
          button.removeAttribute('aria-busy');
        } else {
          const wrap = this.moreWrap;
          if (wrap) wrap.remove();
        }

        const firstNew = cards[0];
        if (firstNew && typeof firstNew.focus === 'function') {
          firstNew.focus({ preventScroll: true });
        }
      } catch (error) {
        console.error('[ff-blog-grid] load more failed, navigating instead', error);
        button.removeAttribute('aria-busy');
        window.location.href = href;
      }
    }

    cacheKey() { return 'ff-blog-counts:' + (this.sectionId || 'blog'); }

    readCache() {
      try { return JSON.parse(sessionStorage.getItem(this.cacheKey()) || '{}') || {}; }
      catch (error) { return {}; }
    }

    writeCache(map) {
      try { sessionStorage.setItem(this.cacheKey(), JSON.stringify(map)); }
      catch (error) {  }
    }

    pendingChips() {
      return Array.from(this.querySelectorAll('.ff-blog-grid__chip[data-tag]')).filter((chip) => {
        if (!chip.dataset.tag) return false;
        const value = chip.querySelector('[data-ff-count-value]');
        return value && !value.textContent.trim();
      });
    }

    setCount(chip, count) {
      const value = chip.querySelector('[data-ff-count-value]');
      const wrap = chip.querySelector('.ff-blog-grid__chip-num');
      if (!value || count === null || count === undefined || count === '') return;
      value.textContent = String(count);
      if (wrap) wrap.hidden = false;
    }

    applyCachedCounts() {
      const cache = this.readCache();
      this.pendingChips().forEach((chip) => {
        if (Object.prototype.hasOwnProperty.call(cache, chip.dataset.tag)) {
          this.setCount(chip, cache[chip.dataset.tag]);
        }
      });
    }

    async warmCounts() {
      if (this.dataset.countFill !== 'true') return;
      if (this.warming) return;

      const chips = this.pendingChips();
      if (!chips.length) return;

      const max = Number(this.dataset.countMax || 12);
      if (!Number.isFinite(max) || chips.length > max) return;

      this.warming = true;
      const cache = this.readCache();
      try {
        for (const chip of chips) {
          const tag = chip.dataset.tag;
          try {
            const root = await this.fetchSection(chip.getAttribute('href'));
            const view = root.querySelector('[data-ff-blog-view]');
            const count = view && view.getAttribute('data-view-count');
            if (count === null || count === '' || Number.isNaN(Number(count))) continue;
            cache[tag] = Number(count);
            const live = this.querySelector('.ff-blog-grid__chip[data-tag="' + CSS.escape(tag) + '"]');
            if (live) this.setCount(live, cache[tag]);
          } catch (error) {
            console.error('[ff-blog-grid] count for "' + tag + '" unavailable', error);
          }
        }
      } finally {
        this.writeCache(cache);
        this.warming = false;
      }
    }
  }

  if (!customElements.get('ff-blog-grid')) customElements.define('ff-blog-grid', FFBlogGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-faq"] && !Shopify.designMode) return;
  try {
    
  class FFFaq extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-ff-faq-list]');
      this.tabs = Array.from(this.querySelectorAll('[data-ff-faq-tab]'));
      this.items = Array.from(this.querySelectorAll('.ff-faq__item'));
      this.closeOthers = this.dataset.closeOthers === 'true';
      this.supportsExclusive = 'name' in document.createElement('details');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.ffFaqTab));
      });

      if (this.closeOthers && !this.supportsExclusive) {
        this.items.forEach((item) => {
          item.addEventListener('toggle', () => {
            if (!item.open) return;
            this.items.forEach((other) => {
              if (other !== item && other.open) other.open = false;
            });
          });
        });
      }

    }

    select(handle) {
      this.tabs.forEach((tab) => {
        const active = tab.dataset.ffFaqTab === handle;
        tab.classList.toggle('ff-faq__chip--active', active);
        tab.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      this.items.forEach((item) => {
        const match = !item.dataset.ffFaqCat || item.dataset.ffFaqCat === handle;
        item.hidden = !match;
        item.open = false;
      });
    }
  }

  if (!customElements.get('ff-faq')) customElements.define('ff-faq', FFFaq);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-feature-list"] && !Shopify.designMode) return;
  try {
    
  class FFFeatureList extends HTMLElement {
    connectedCallback() {
      this.tagSlot = this.querySelector('[data-ff-fl-tag-slot]');
      if (!this.tagSlot) return;
      this.media = this.querySelector('[data-ff-fl-media]');
      this.mediaInner = this.querySelector('[data-ff-fl-media-inner]');
      this.mobile = window.matchMedia('(max-width: 989px)');
      this.fit = this.fit.bind(this);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.fit);
      this.fit();
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.fit);
        this.ro.observe(this);
      }
      this.mobile.addEventListener('change', this.fit);
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      if (this.mobile) this.mobile.removeEventListener('change', this.fit);
    }

    // A rotated element reserves only its unrotated layout box, but the design reserves
    // the rotated visual box. getBoundingClientRect on the rotated child IS that visual
    // box, so the slot is grown to it rather than to a hardcoded height.
    fit() {
      this.fitTag();
      this.fitMedia();
    }

    fitTag() {
      const tag = this.tagSlot.firstElementChild;
      if (!tag) return;
      this.tagSlot.style.height = '';
      const h = tag.getBoundingClientRect().height;
      if (h > 0) this.tagSlot.style.height = `${h}px`;
    }

    // Figma sizes the media wrapper as the rotated BOUNDING box, but on the axis that
    // governs layout at that breakpoint: desktop is a row so the width is reserved and
    // the rotated height is allowed to overflow; mobile is a stack so the height is
    // reserved and the inner runs full width. Both are solved from the rotation rather
    // than hardcoded, so changing the rotation setting stays correct.
    fitMedia() {
      if (!this.media || !this.mediaInner) return;
      const deg = parseFloat(getComputedStyle(this).getPropertyValue('--ff-fl-media-rotation'));
      if (!isFinite(deg)) return;
      const r = Math.abs(deg) * Math.PI / 180;
      const cos = Math.cos(r);
      const sin = Math.sin(r);
      if (cos === 0) return;
      const W = this.media.clientWidth;
      const H = this.media.clientHeight;
      if (W <= 0 || H <= 0) return;
      if (this.mobile.matches) {
        this.mediaInner.style.width = `${W}px`;
        this.mediaInner.style.height = `${Math.max(0, (H - W * sin) / cos)}px`;
      } else {
        this.mediaInner.style.height = `${H}px`;
        this.mediaInner.style.width = `${Math.max(0, (W - H * sin) / cos)}px`;
      }
    }
  }

  if (!customElements.get('ff-feature-list')) customElements.define('ff-feature-list', FFFeatureList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-footer"] && !Shopify.designMode) return;
  try {
    
  class FFFooter extends HTMLElement {
    connectedCallback() {
      this.mq = window.matchMedia('(min-width: 990px)');
      this.columns = [...this.querySelectorAll('details.ff-footer__column')];
      this.sync = this.sync.bind(this);
      this.guard = this.guard.bind(this);
      this.sync();
      this.mq.addEventListener('change', this.sync);
      this.columns.forEach((d) => d.querySelector('summary')?.addEventListener('click', this.guard));
      this.bindNewsletter();
      this.clampOverscroll();
    }

    disconnectedCallback() {
      this.mq?.removeEventListener('change', this.sync);
    }

    sync() {
      const desktop = this.mq.matches;
      this.columns.forEach((d, i) => {
        if (desktop) d.open = true;
        else d.open = i === 0;
      });
    }

    guard(event) {
      if (this.mq.matches) event.preventDefault();
    }

    bindNewsletter() {
      this.form = this.querySelector('.ff-footer__newsletter-form');
      this.newsletter = this.querySelector('.ff-footer__newsletter');
      if (!this.form) return;
      const d = this.newsletter?.dataset || {};

      if (d.destination === 'klaviyo' && d.klaviyoKey) {
        this.bindKlaviyoSubmit(d);
        return;
      }
      if (d.inlineSubmit === 'false') return;
      this.bindRetargetedSubmit(d);
    }

    bindRetargetedSubmit(d) {
      const name = 'ff-newsletter-sink-' + Math.random().toString(36).slice(2);
      const frame = document.createElement('iframe');
      frame.name = name;
      frame.setAttribute('aria-hidden', 'true');
      frame.setAttribute('tabindex', '-1');
      frame.setAttribute('sandbox', 'allow-same-origin');
      frame.setAttribute('title', '');
      frame.style.cssText = 'position:absolute;width:0;height:0;border:0;overflow:hidden;clip:rect(0 0 0 0)';
      this.appendChild(frame);
      this.form.target = name;

      let armed = false;
      let watchdog = null;
      let surrendered = false;

      const surrender = () => {
        if (surrendered) return;
        surrendered = true;
        clearTimeout(watchdog);
        this.form.removeAttribute('target');
        this.form.removeAttribute('aria-busy');
        frame.remove();
        this.form.submit();
      };

      this.form.addEventListener('submit', () => {
        const email = this.form.querySelector('input[type="email"]');
        if (email && !email.checkValidity()) return;
        if (surrendered) return;
        armed = true;
        this.form.setAttribute('aria-busy', 'true');
        clearTimeout(watchdog);
        watchdog = setTimeout(surrender, 12000);
      });

      frame.addEventListener('load', () => {
        if (!armed) return;
        armed = false;
        clearTimeout(watchdog);
        this.form.removeAttribute('aria-busy');

        this.message({ text: d.successText || 'Thanks for subscribing.', kind: 'success' });

        frame.src = 'about:blank';
      });
    }

    bindKlaviyoSubmit(d) {

      this.form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (this.busy) return;
        const email = this.form.querySelector('input[type="email"]');
        if (email && !email.checkValidity()) { email.reportValidity(); return; }
        this.busy = true;
        this.form.setAttribute('aria-busy', 'true');
        try {
          const posted = await this.postToKlaviyo(email ? email.value : '', d);
          this.message(posted
            ? { text: d.successText || 'Thanks for subscribing.', kind: 'success' }
            : { text: d.errorText || 'Sorry, that did not work. Please try again.', kind: 'error' });
        } catch (e) {
          this.message({ text: d.errorText || 'Sorry, that did not work. Please try again.', kind: 'error' });
        }
        this.form.removeAttribute('aria-busy');
        this.busy = false;
      });
    }

    async postToKlaviyo(emailValue, d) {
      const attributes = { profile: { data: { type: 'profile', attributes: { email: emailValue } } } };
      const body = { data: { type: 'subscription', attributes } };
      if (d.klaviyoList) body.data.relationships = { list: { data: { type: 'list', id: d.klaviyoList } } };
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(d.klaviyoKey)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(body),
      });
      return response.ok;
    }

    clampOverscroll() {
      const html = document.documentElement;
      const clamp = () => {
        if (!/^(hidden|clip)$/.test(getComputedStyle(html).overflowY)) return;
        if (html.scrollTop !== 0) html.scrollTop = 0;
        const wrap = document.querySelector('.page-wrapper');
        if (!wrap) return;
        const max = wrap.scrollHeight - wrap.clientHeight;
        if (max >= 0 && wrap.scrollTop > max) wrap.scrollTop = max;
      };
      clamp();
      window.addEventListener('load', clamp, { once: true });
      document.fonts?.ready.then(clamp).catch(() => {});
      if (window.ResizeObserver) new ResizeObserver(clamp).observe(this);
      window.addEventListener('scroll', clamp, { passive: true, capture: true });

      const until = Date.now() + 6000;
      const pin = () => { clamp(); if (Date.now() < until) requestAnimationFrame(pin); };
      requestAnimationFrame(pin);
    }

    message({ text, kind }) {
      this.form.querySelector('.ff-footer__newsletter-message')?.remove();
      const p = document.createElement('p');
      p.className = `ff-footer__newsletter-message ff-footer__newsletter-message--${kind}`;
      p.setAttribute('role', kind === 'success' ? 'status' : 'alert');
      p.textContent = text;
      this.form.appendChild(p);
      if (kind === 'success') this.form.reset();
    }
  }

  if (!customElements.get('ff-footer')) customElements.define('ff-footer', FFFooter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-header"] && !Shopify.designMode) return;
  try {
    
  class FFHeader extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('[data-ff-header-drawer]');
      this.toggle = this.querySelector('[data-ff-header-toggle]');

      this.portalLink = this.querySelector('[data-ff-portal-link]');
      if (this.portalLink) {
        this.portalLink.addEventListener('click', (event) => this.openPortal(event));
      }

      if (this.drawer && this.toggle) {
        this.toggle.addEventListener('click', () => this.open());
        this.querySelector('[data-ff-header-close]')?.addEventListener('click', () => this.close());
        this.drawer.addEventListener('close', () => this.toggle.setAttribute('aria-expanded', 'false'));
        this.drawer.addEventListener('click', (event) => {
          if (event.target === this.drawer) this.close();
        });
      }

      for (const name of ['cart:updated', 'ff:cart:updated']) {
        document.addEventListener(name, (event) => {
          const detail = event.detail || {};
          const count = detail.cart?.item_count ?? detail.item_count;
          if (typeof count === 'number') this.setCount(count);
        });
      }

      document.addEventListener('shopify:cart:lines-update', (event) => {
        event.promise
          ?.then(({ cart, detail }) => {
            const count = cart?.totalQuantity ?? detail?.itemCount;
            if (typeof count === 'number') this.setCount(count);
          })
          .catch(() => {});
      });

      this.initRangeMenu();
      this.initDeliveryBar();
      // syncAccountLabel() runs AFTER applyRealHeaderState(), not in parallel with it: the
      // latter may replace the logged-out circle with a freshly-built pill containing its own
      // [data-ff-account-label] span, which the former only finds by querying the DOM at the
      // moment it runs.
      this.applyRealHeaderState().then(() => this.syncAccountLabel());

      // A customer landing back on this exact page right after completing sign-in (the OAuth
      // redirect_uri is this store's own /pages/account, so no navigation away-and-back
      // necessarily happens) can have this very check above run before
      // snippets/ff-account-auth.liquid's own token exchange has finished writing the session
      // -- both are independent scripts on the same page load, and nothing previously told
      // this component "the session that didn't exist a moment ago now does." Confirmed live
      // 2026-09-19: on first sign-in the header stayed on its logged-out/generic state (no
      // "Hi, <name>" pill, generic delivery banner) until some unrelated click happened to
      // trigger a fresh check elsewhere. ff-account-auth.liquid now dispatches this the
      // instant a new session is actually established -- re-running the exact same two calls
      // above closes the gap regardless of which of them lost that particular race.
      this._onSignedIn = () => {
        this.resolveNextDelivery();
        this.applyRealHeaderState().then(() => this.syncAccountLabel());
      };
      document.addEventListener('ff:account:signed-in', this._onSignedIn);
    }

    // The account chip's label is server-rendered from the classic `customer` object, which
    // (same as everywhere else in this build -- see snippets/ff-account-auth.liquid) isn't
    // reliably populated on this store outside the account page. Unconditional, not gated
    // behind data-delivery-fetch like the subscription bar below: any signed-in customer
    // should see their own name, whether or not this template fetches delivery info. Reuses
    // whatever FFAccountAuth.bootstrap() already resolved elsewhere on the page rather than
    // triggering its own sign-in attempt -- bootstrap() is memoized, so this is a second
    // caller, not a second redirect.
    async syncAccountLabel() {
      const labels = this.querySelectorAll('[data-ff-account-label]');
      if (!labels.length) return;
      try {
        if (!(await window.ffWaitForAccountAuth())) return;
        await window.FFAccountAuth.bootstrap();
        const firstName = await window.FFAccountAuth.getCustomerFirstName();
        if (!firstName) return; // no session, or a session with no name on file — leave as rendered.
        const prefix = this.dataset.welcomePrefix || 'Hi,';
        labels.forEach((label) => { label.textContent = `${prefix} ${firstName}`; });
      } catch (error) {
        // Silent — the server-rendered fallback label is already a valid, complete state.
      }
    }

    // The account and box/cart controls render as ENTIRELY DIFFERENT elements by logged_in
    // state -- a plain icon circle when logged out, a labelled pill when logged in (see this
    // file's own top-of-file doc comment, "THREE STATES") -- not one element toggled by a
    // class or [hidden]. `logged_in` is server-side, from the classic `customer` object,
    // which this store's New Customer Accounts setup does not reliably populate outside the
    // account page (confirmed live 2026-09-15, see snippets/ff-account-auth.liquid). A
    // genuinely signed-in customer whose page happened to render with `customer` blank saw
    // the logged-OUT circles regardless. This reconstructs the pill markup Liquid would have
    // rendered, once a real client-side session confirms the true state -- cloning the
    // existing icon spans rather than re-embedding the SVGs here, so the actual glyphs stay
    // single-sourced in the Liquid template.
    async applyRealHeaderState() {
      try {
        if (!(await window.ffWaitForAccountAuth())) return;
        await window.FFAccountAuth.bootstrap();
        if (!window.FFAccountAuth.getAccessToken()) return; // genuinely logged out — rendered state stands.

        this.classList.add('ff-header--logged-in');
        // Inline style, not the hidden attribute -- .ff-header__pill has an unconditional
        // display: inline-flex with no [hidden] override, the same recurring failure mode
        // caught twice already in this build (Box Builder's purchase-type panel, most
        // recently). Confirmed against that exact bug rather than assumed here.
        this.querySelectorAll('.ff-header__cta').forEach((cta) => { cta.style.display = 'none'; });

        // FAF001P-155: hiding the CTA above fixes the account/box pills, but the nav's own
        // LINK LIST (menu vs menu_logged_in in this file's own Liquid) is a completely
        // separate server-side choice, from the same unreliable classic `customer` object --
        // a customer signed in via the Customer Account API kept seeing the logged-out link
        // list (no "Shop the range" trigger) on every page but /pages/account. A hidden
        // <template data-ff-nav-menu-alt> carrying the logged-in menu's markup only exists
        // when Liquid's own logged_in came back false, so this is a no-op whenever the
        // server already rendered correctly.
        this.querySelectorAll('template[data-ff-nav-menu-alt]').forEach((tpl) => {
          const isDrawer = tpl.dataset.ffNavMenuAlt === 'drawer';
          const target = this.querySelector(isDrawer ? '[data-ff-nav-menu-drawer]' : '[data-ff-nav-menu]');
          if (!target) { tpl.remove(); return; }
          target.replaceChildren(tpl.content.cloneNode(true));
          tpl.remove();

          // The trigger button this swap just replaced took its click listener down with
          // it -- initRangeMenu() only ran once, at connectedCallback(), against whichever
          // trigger the server actually rendered. Re-resolving and re-binding just the
          // trigger (not the document-level listeners bindRangeTrigger() also sets up on
          // its first real call, which stay correctly targeted at `this.rangePanel`/
          // `this.rangeTrigger` by reference once those are reassigned) is the minimum
          // needed to make "Shop the range" openable again post-swap.
          if (isDrawer) {
            this.drawerTrigger = this.querySelector('[data-ff-drawer-range-trigger]');
            this.drawerPanel = this.querySelector('[data-ff-drawer-range]');
            this.bindDrawerRangeTrigger();
          } else {
            this.rangeTrigger = this.querySelector('[data-ff-range-trigger]');
            this.bindRangeTrigger();
          }
        });

        const accountCircle = this.querySelector('[data-ff-account-circle]');
        if (accountCircle) {
          const pill = document.createElement('a');
          pill.className = 'ff-header__pill ff-header__pill--account';
          pill.href = this.dataset.accountLink || accountCircle.href;
          pill.setAttribute('data-ff-account-chip', '');
          const label = document.createElement('span');
          label.className = 'ff-header__pill-label';
          label.setAttribute('data-ff-account-label', '');
          label.textContent = this.dataset.accountNoNameLabel || 'My account'; // syncAccountLabel() fills in the real name right after this runs.
          pill.appendChild(label);
          const icon = accountCircle.querySelector('.ff-header__icon');
          if (icon) pill.appendChild(icon.cloneNode(true));
          accountCircle.replaceWith(pill);
        }

        const hasSubscription = await window.FFAccountAuth.hasActiveSubscription(this.dataset.boxProductId);
        const boxCircle = this.querySelector('[data-ff-box-circle]');
        if (boxCircle) {
          const pill = document.createElement('a');
          const label = document.createElement('span');
          label.className = 'ff-header__pill-label';
          const icon = boxCircle.querySelector('.ff-header__icon--basket');
          const dot = boxCircle.querySelector('[data-ff-cart-dot]');

          if (hasSubscription) {
            pill.className = 'ff-header__pill ff-header__pill--accent ff-header__box';
            label.textContent = this.dataset.boxLabelSubscribed || 'My Box';
            if (this.dataset.boxLinkSubscribed) {
              pill.href = this.dataset.boxLinkSubscribed;
            } else {
              pill.href = this.dataset.accountLink || boxCircle.href;
              pill.setAttribute('data-ff-portal-link', '');
              pill.addEventListener('click', (event) => this.openPortal(event));
            }
            pill.appendChild(label);
            if (icon) pill.appendChild(icon.cloneNode(true));
            if (dot) pill.appendChild(dot.cloneNode(true));
          } else {
            pill.className = 'ff-header__pill ff-header__pill--primary ff-header__box';
            label.textContent = this.dataset.boxLabelUnsubscribed || 'Start your box';
            pill.href = this.dataset.boxLinkUnsubscribed || boxCircle.href;
            pill.appendChild(label);
          }
          boxCircle.replaceWith(pill);
          if (hasSubscription) this.classList.add('ff-header--subscribed');
        }

        // The delivery-date strip's markup no longer depends on the classic `logged_in`
        // check to exist in the DOM (see delivery_fetch in this file's own Liquid) -- it's
        // rendered, hidden, for any visitor whenever the delivery_bar setting is on, and
        // resolveNextDelivery()/fetchNextDelivery() unhide it once a real client-side
        // session and subscription are found. Nothing to do here any more.
      } catch (error) {
        // Silent — the server-rendered logged-out controls are already a valid, complete state.
      }
    }

    disconnectedCallback() {
      if (this._onDocPointerDown) document.removeEventListener('pointerdown', this._onDocPointerDown);
      if (this._onDocKeyDown) document.removeEventListener('keydown', this._onDocKeyDown);
      if (this._mobileQuery && this._onBreakpoint) this._mobileQuery.removeEventListener('change', this._onBreakpoint);
      if (this._onDeliveryRefresh) {
        document.removeEventListener('ff:subscription:updated', this._onDeliveryRefresh);
        document.removeEventListener('visibilitychange', this._onVisibility);
        window.removeEventListener('pageshow', this._onPageShow);
      }
      if (this._onSignedIn) document.removeEventListener('ff:account:signed-in', this._onSignedIn);
    }

    initRangeMenu() {
      this.rangeTrigger = this.querySelector('[data-ff-range-trigger]');
      this.rangePanel = this.querySelector('[data-ff-range-panel]');
      this.bindRangeTrigger();

      this.drawerTrigger = this.querySelector('[data-ff-drawer-range-trigger]');
      this.drawerPanel = this.querySelector('[data-ff-drawer-range]');
      this.bindDrawerRangeTrigger();
    }

    // Split out of initRangeMenu() so applyRealHeaderState()'s nav-menu swap (FAF001P-155)
    // can re-bind a freshly-cloned trigger without re-registering the document-level
    // listeners a second time. `_rangeDocListenersBound` guards ONLY that part: the trigger's
    // own click listener always (re)binds, since it lived on the DOM node the swap just
    // replaced, not on this component -- but the document/media-query listeners read
    // `this.rangePanel`/`this.rangeTrigger` by reference at call time, not by a captured
    // local, so reassigning those two properties before calling this again is enough to
    // retarget them at the new node without adding a second copy of each listener.
    bindRangeTrigger() {
      if (!this.rangeTrigger || !this.rangePanel) return;
      this.rangeTrigger.addEventListener('click', () => this.toggleRange());
      if (this._rangeDocListenersBound) return;
      this._rangeDocListenersBound = true;

      for (const item of this.rangePanel.querySelectorAll('[data-ff-range-item]')) {
        item.addEventListener('click', () => this.closeRange());
      }

      this._onDocPointerDown = (event) => {
        if (this.rangePanel.hidden) return;
        if (this.rangePanel.contains(event.target) || this.rangeTrigger.contains(event.target)) return;
        this.closeRange();
      };
      document.addEventListener('pointerdown', this._onDocPointerDown);

      this._onDocKeyDown = (event) => {
        if (event.key !== 'Escape' || this.rangePanel.hidden) return;
        this.closeRange();
        this.rangeTrigger.focus();
      };
      document.addEventListener('keydown', this._onDocKeyDown);

      this._mobileQuery = window.matchMedia('(max-width: 989px)');
      this._onBreakpoint = (event) => {
        if (event.matches) this.closeRange();
      };
      this._mobileQuery.addEventListener('change', this._onBreakpoint);
    }

    // Only ever called against a node the caller just inserted fresh (connectedCallback()'s
    // own server-rendered one, or the nav-menu swap's freshly-cloned one) -- never re-run
    // against an unchanged, already-bound node, so no duplicate-listener guard is needed
    // here the way bindRangeTrigger() above needs one for its document-level listeners.
    bindDrawerRangeTrigger() {
      if (!this.drawerTrigger || !this.drawerPanel) return;
      this.drawerTrigger.addEventListener('click', () => {
        const isOpen = this.drawerTrigger.getAttribute('aria-expanded') === 'true';
        this.drawerTrigger.setAttribute('aria-expanded', String(!isOpen));
        this.drawerPanel.hidden = isOpen;
      });
    }

    toggleRange() {
      if (this.rangePanel.hidden) this.openRange();
      else this.closeRange();
    }

    openRange() {
      this.rangePanel.hidden = false;
      this.rangeTrigger.setAttribute('aria-expanded', 'true');
      this.classList.add('ff-header--menu-open');
    }

    closeRange() {
      if (!this.rangePanel) return;
      this.rangePanel.hidden = true;
      this.rangeTrigger.setAttribute('aria-expanded', 'false');
      this.classList.remove('ff-header--menu-open');
    }

    initDeliveryBar() {
      this.deliveryBar = this.querySelector('[data-ff-delivery]');
      if (!this.deliveryBar || !this.hasAttribute('data-delivery-fetch')) return;

      this.resolveNextDelivery();

      this._onDeliveryRefresh = () => this.resolveNextDelivery();
      document.addEventListener('ff:subscription:updated', this._onDeliveryRefresh);

      this._onPageShow = (event) => {
        if (event.persisted) this.resolveNextDelivery();
      };
      window.addEventListener('pageshow', this._onPageShow);

      this._onVisibility = () => {
        if (document.visibilityState !== 'visible') return;
        if (Date.now() - (this._deliveryResolvedAt || 0) < 60000) return;
        this.resolveNextDelivery();
      };
      document.addEventListener('visibilitychange', this._onVisibility);
    }

    resolveNextDelivery() {
      if (this._deliveryPending) return this._deliveryPending;
      this._deliveryPending = this.fetchNextDelivery().finally(() => {
        this._deliveryPending = null;
        this._deliveryResolvedAt = Date.now();
      });
      return this._deliveryPending;
    }

    async fetchNextDelivery() {
      try {
        const ready = await this.ensureRecharge('subscription');
        if (!ready) return;

        await window.recharge.init({
          storeIdentifier: this.dataset.shopDomain,
          storefrontAccessToken: this.dataset.storefrontAccessToken,
          appName: 'Header',
          appVersion: '1.0.0',
        });

        // This store is on New Customer Accounts, which never sets the classic session
        // loginShopifyAppProxy() needs -- see snippets/ff-account-auth.liquid for why.
        //
        // Goes through FFAccountAuth's shared getActiveSubscriptions() rather than this
        // component's own raw bootstrap()+loginToRecharge()+listSubscriptions() (what used to
        // be here) -- that shared method has a bounded retry for the documented race where a
        // listSubscriptions() call made too soon after loginWithShopifyCustomerAccount()
        // comes back empty even though the login itself succeeded. The raw call here had no
        // such retry, so right after a fresh sign-in this delivery bar could stay hidden
        // while applyRealHeaderState()'s account-pill check (which already used the shared,
        // retried method) correctly showed "My Box" -- confirmed live 2026-09-19: exactly
        // that split, "Hi, <name>"/"My Box" pill correct, delivery bar not, on the same load.
        if (!(await window.ffWaitForAccountAuth())) {
          console.warn('[ff-header] fetchNextDelivery: FFAccountAuth never became available');
          return;
        }
        // Dropped by mistake in the previous pass -- getActiveSubscriptions() reads the
        // session straight out of sessionStorage with no waiting of its own; bootstrap() is
        // what actually populates it (silently re-authenticating if needed). Without this,
        // this call path could ask for the session before sign-in had genuinely run at all
        // on this page load, independent of the race the previous fix targeted.
        await window.FFAccountAuth.bootstrap();
        // The markup this method populates is no longer gated behind the server's classic
        // `logged_in` check (see delivery_fetch in this file's own Liquid), so this now runs
        // for every visitor, anonymous included. Bail here, before the subscriptions call,
        // for a visitor with no session at all -- the common case site-wide -- rather than
        // asking Recharge for subscriptions no token could ever have, and rather than logging
        // the diagnostic below for a case that isn't an anomaly.
        if (!window.FFAccountAuth.getAccessToken()) return;
        const subscriptions = await window.FFAccountAuth.getActiveSubscriptions();
        const next = this.soonestChargeDate(subscriptions || []);
        // Diagnostic only, not a behaviour change -- this bar has been reported live,
        // repeatedly, as staying on its generic/hidden state even when the account pill
        // right next to it correctly shows an active subscription, and every attempt to
        // find the cause from static code reading alone has come up empty. Logs exactly
        // what this method actually saw, so the next real occurrence is traceable from the
        // browser console instead of guessed at again.
        if (!next) {
          console.warn('[ff-header] fetchNextDelivery: no delivery date resolved', {
            boxProductId: this.dataset.boxProductId,
            subscriptionCount: subscriptions?.length ?? 0,
            subscriptions: (subscriptions || []).map((sub) => ({
              productId: sub?.external_product_id,
              nextCharge: sub?.next_charge_scheduled_at,
              status: sub?.status,
            })),
          });
        }
        if (next) this.showDeliveryDate(next);
        else this.hideDeliveryDate();
      } catch (error) {
        console.warn('[ff-header] fetchNextDelivery threw', error);
        this.hideDeliveryDate();
      }
    }

    soonestChargeDate(subscriptions) {
      const boxProductId = this.dataset.boxProductId;
      const candidates = (boxProductId
        ? subscriptions.filter((sub) => String(sub.external_product_id?.ecommerce) === String(boxProductId))
        : subscriptions
      // Same exclusion as sections/ff-manage-subscription.liquid's resolveSubscription() --
      // without it, a cancelled subscription's own stale next_charge_scheduled_at could be
      // picked as "soonest" and shown here while the account page correctly ignores it,
      // confirmed live: this bar and the Next Delivery card disagreeing by more than the
      // billing-to-delivery offset alone could ever explain.
      ).filter((sub) => !(sub.status && /cancel/i.test(sub.status)));
      const dated = [];
      for (const sub of candidates) {
        const value = this.calendarDate(sub?.next_charge_scheduled_at);
        if (value) dated.push(value);
      }
      if (!dated.length) return null;

      let soonest = null;
      for (const value of dated) {
        if (!soonest || value < soonest) soonest = value;
      }
      // next_charge_scheduled_at is the BILLING date -- this bar is customer-facing and must
      // show the real delivery date, same change_date_lead_days conversion and same setting
      // as sections/ff-manage-subscription.liquid's deliveryDateFromCharge(), so the two can
      // never disagree about what "next delivery" means.
      return this.deliveryDateFromCharge(soonest);
    }

    calendarDate(raw) {
      if (typeof raw !== 'string') return null;
      const parts = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (!parts) return null;
      const value = new Date(Date.UTC(Number(parts[1]), Number(parts[2]) - 1, Number(parts[3])));
      return Number.isNaN(value.getTime()) ? null : value;
    }

    deliveryDateFromCharge(chargeDate) {
      // This file's dates are UTC-midnight by construction (calendarDate() above,
      // formatDeliveryDate() below) -- setUTCDate() keeps the offset in that same space,
      // rather than setDate(), which would reintroduce a local-timezone shift.
      const leadDays = parseInt(this.dataset.changeDateLeadDays, 10) || 3;
      const value = new Date(chargeDate.getTime());
      value.setUTCDate(value.getUTCDate() + leadDays);
      return value;
    }

    formatDeliveryDate(value) {
      return value.toLocaleDateString(this.dataset.deliveryLocale || 'en-GB', {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC',
      });
    }

    showDeliveryDate(value) {
      const dateEl = this.deliveryBar.querySelector('[data-ff-delivery-date]');
      const group = this.deliveryBar.querySelector('[data-ff-delivery-group]');
      if (!dateEl || !group) return;

      dateEl.textContent = this.formatDeliveryDate(value);
      group.hidden = false;
      const message = this.deliveryBar.querySelector('[data-ff-delivery-message]');
      if (message) message.hidden = true;
      this.deliveryBar.hidden = false;
      this.setAnnouncementHidden(true);
    }

    hideDeliveryDate() {
      const group = this.deliveryBar.querySelector('[data-ff-delivery-group]');
      if (group) group.hidden = true;

      const message = this.deliveryBar.querySelector('[data-ff-delivery-message]');
      const hasMessage = message && message.textContent.trim() !== '';
      if (message) message.hidden = !hasMessage;
      this.deliveryBar.hidden = !hasMessage;
      this.setAnnouncementHidden(false);
    }

    setAnnouncementHidden(hidden) {
      if (!this.hasAttribute('data-delivery-replaces-bar')) return;
      for (const bar of document.querySelectorAll('ff-announcement')) bar.hidden = hidden;
    }

    open() {
      this.drawer.showModal();
      this.toggle.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.drawer.close();
    }

    setCount(count) {
      for (const dot of this.querySelectorAll('[data-ff-cart-dot]')) {
        dot.toggleAttribute('hidden', count === 0);
      }
    }

    async ensureRecharge(namespace, timeoutMs = 8000) {
      const version = this.dataset.sdkVersion || '1.51.0';
      if (window.recharge && window.recharge[namespace]) return true;

      if (!document.querySelector('[data-ff-recharge-sdk]')) {
        const script = document.createElement('script');
        script.src = `https://static.rechargecdn.com/assets/storefront/recharge-client-${version}.min.js`;
        script.setAttribute('data-ff-recharge-sdk', '');
        document.head.appendChild(script);
      }

      const start = Date.now();
      while (!(window.recharge && window.recharge[namespace])) {
        if (Date.now() - start > timeoutMs) return false;
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      return true;
    }

    async openPortal(event) {
      event.preventDefault();
      const fallbackHref = this.portalLink.href;
      this.portalLink.setAttribute('aria-busy', 'true');

      try {
        const ready = await this.ensureRecharge('customer');
        if (!ready) throw new Error('Recharge SDK unavailable');

        await window.recharge.init({
          storeIdentifier: this.dataset.shopDomain,
          storefrontAccessToken: this.dataset.storefrontAccessToken,
          appName: 'Header',
          appVersion: '1.0.0',
        });

        // This store is on New Customer Accounts, which never sets the classic session
        // loginShopifyAppProxy() needs -- see snippets/ff-account-auth.liquid for why.
        if (!(await window.ffWaitForAccountAuth())) throw new Error('Recharge SDK unavailable');
        await window.FFAccountAuth.bootstrap();
        const auth = await window.FFAccountAuth.loginToRecharge();
        if (!auth?.customerId) throw new Error('No customer session');

        const access = await window.recharge.customer.getCustomerPortalAccess(auth, {});
        if (!access?.portal_url) throw new Error('No portal URL returned');

        window.location.href = access.portal_url;
      } catch (error) {
        window.location.href = fallbackHref;
      }
    }
  }

  if (!customElements.get('ff-header')) customElements.define('ff-header', FFHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const apply = () => {
      document.querySelectorAll('.ff-hero').forEach((hero) => {
        if (hero.dataset.overlayHeader !== 'true') return;
        const section = hero.closest('.ff-hero-section') || hero.parentElement;
        const header = document.querySelector('.ff-header');
        if (!section || !header) return;
        const measured = header.getBoundingClientRect().height;
        if (!measured) return;
        const next = `${measured.toFixed(2)}px`;
        ['--ff-hero-overlay-header', '--ff-hero-overlay-header-mobile'].forEach((prop) => {
          const current = parseFloat(getComputedStyle(section).getPropertyValue(prop));
          if (!Number.isFinite(current) || Math.abs(current - measured) > 0.5) {
            section.style.setProperty(prop, next);
          }
        });
      });
    };
    const fitBadge = () => {
      document.querySelectorAll('.ff-hero__badge').forEach((slot) => {
        const tag = slot.querySelector('.ff-section-tag');
        if (!tag) return;
        const visual = tag.getBoundingClientRect().height;
        const layout = tag.offsetHeight;
        if (!visual || !layout) return;
        const reserve = Math.max(0, (visual - layout) / 2);
        slot.style.setProperty('--ff-hero-badge-reserve', `${reserve.toFixed(2)}px`);
      });
    };
    const applyAll = () => { apply(); fitBadge(); };
    const run = () => { applyAll(); if (document.fonts && document.fonts.ready) document.fonts.ready.then(applyAll); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
    let t;
    window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(applyAll, 120); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-insta-slider"] && !Shopify.designMode) return;
  try {
    
  class FFInstaSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-ff-is-track]');
      if (!this.track) return;
      this.tagSlot = this.querySelector('[data-ff-is-tag-slot]');
      this.prev = [...this.querySelectorAll('.ff-insta__arrow--prev')];
      this.next = [...this.querySelectorAll('.ff-insta__arrow--next')];

      this.prev.forEach((b) => b.addEventListener('click', () => this.step(-1)));
      this.next.forEach((b) => b.addEventListener('click', () => this.step(1)));

      this.update = this.update.bind(this);
      this.fit = this.fit.bind(this);
      this.settle = this.settle.bind(this);
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(this.settle, 80);
      }, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.fit);
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => { this.fit(); this.measureLoop(); this.normalise(); this.update(); });
        this.ro.observe(this);
      }
      this.fit();
      this.setupLoop();
      this.update();
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
    }

    fit() {
      if (!this.tagSlot) return;
      const tag = this.tagSlot.firstElementChild;
      if (!tag) return;
      this.tagSlot.style.height = '';
      const h = tag.getBoundingClientRect().height;
      if (h > 0) this.tagSlot.style.height = `${h}px`;
    }

    get stride() {
      const items = this.track.children;
      if (!items.length) return 0;
      return items[1] ? items[1].offsetLeft - items[0].offsetLeft : items[0].offsetWidth;
    }

    setupLoop() {
      if (this.looping) return;
      const originals = [...this.track.children].filter((el) => !el.hasAttribute('data-ff-clone'));
      if (originals.length < 2) return;
      if (this.track.scrollWidth <= this.track.clientWidth + 1) return;

      this.originalCount = originals.length;
      for (let copy = 0; copy < 2; copy += 1) {
        const fragment = document.createDocumentFragment();
        originals.forEach((el) => {
          const clone = el.cloneNode(true);
          clone.setAttribute('data-ff-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((f) => {
            f.setAttribute('tabindex', '-1');
          });
          fragment.appendChild(clone);
        });
        this.track.appendChild(fragment);
      }

      this.looping = true;
      this.setAttribute('data-ff-looping', '');
      this.measureLoop();
      if (this.setWidth) this.jump(this.setWidth);
    }

    measureLoop() {
      if (!this.looping) return;
      const items = this.track.children;
      const first = items[0];
      const firstClone = items[this.originalCount];
      if (!first || !firstClone) return;
      this.setWidth = firstClone.offsetLeft - first.offsetLeft;
    }

    jump(to) {
      const previous = this.track.style.scrollBehavior;
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft = to;
      this.track.style.scrollBehavior = previous;
    }

    settle() {
      this.normalise();
      this.update();
    }

    normalise() {
      if (!this.looping || !this.setWidth) return;
      const L = this.setWidth;
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (max <= L) return;
      const x = this.track.scrollLeft;
      let target = x + Math.round((max / 2 - x) / L) * L;
      while (target < 0) target += L;
      while (target > max) target -= L;
      if (Math.abs(target - x) > 0.5) this.jump(target);
    }

    step(direction) {
      this.track.scrollBy({ left: this.stride * direction });
    }

    update() {
      if (this.looping) {
        this.prev.forEach((b) => { b.disabled = false; });
        this.next.forEach((b) => { b.disabled = false; });
        return;
      }
      const max = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      this.prev.forEach((b) => { b.disabled = x <= 1; });
      this.next.forEach((b) => { b.disabled = x >= max - 1 || max <= 1; });
    }
  }

  if (!customElements.get('ff-insta-slider')) customElements.define('ff-insta-slider', FFInstaSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-logo-ticker"] && !Shopify.designMode) return;
  try {
    
  class FFLogoTicker extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.ff-logo-ticker__viewport');
      this.tracks = [...this.querySelectorAll('.ff-logo-ticker__track')];
      if (!this.viewport || !this.tracks.length) return;

      this.mq = window.matchMedia('(max-width: 989px)');
      this.sync = this.sync.bind(this);
      this.sync();
      this.mq.addEventListener('change', this.sync);
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.sync);
        this.ro.observe(this.viewport);
      }
    }

    disconnectedCallback() {
      this.mq?.removeEventListener('change', this.sync);
      this.ro?.disconnect();
    }

    get scrolling() {
      return this.classList.contains('ff-logo-ticker--marquee') || this.mq.matches;
    }

    sync() {
      if (!this.scrolling) {
        this.style.removeProperty('--ff-lt-duration');
        this.ensureClone(false);
        return;
      }
      this.ensureClone(true);
      const width = this.tracks[0].scrollWidth;
      const speed = Math.max(10, Number(this.dataset.speed) || 40);
      this.style.setProperty('--ff-lt-duration', `${(width / speed).toFixed(2)}s`);
    }

    // FAF001P-154, confirmed live 2026-09-22: a single clone (two tracks total) only
    // covers 2x this content's own width. The seamless-loop trick below only stays
    // seamless while there's ALWAYS at least one full viewport's worth of track content
    // still ahead, at every point in the scroll -- with just two tracks that stops being
    // true the moment the viewport is wider than roughly one track (this store's real
    // numbers: ~712px of logos against a ~1240px+ desktop viewport), so partway through
    // every cycle the trailing track had already scrolled off and the next hadn't caught
    // up yet, showing a stretch of bare background where logos should be -- what looked
    // like the strip "disappearing" instead of circling round. Clones however many are
    // actually needed for THIS viewport and THIS content, not a fixed one, and always
    // clones the ORIGINAL (this.tracks[0]) rather than a clone of a clone, so every copy
    // stays pixel-identical.
    ensureClone(wanted) {
      const clones = [...this.viewport.querySelectorAll('[data-ff-lt-clone]')];
      if (!wanted) {
        if (clones.length) {
          clones.forEach((clone) => clone.remove());
          this.tracks = [...this.querySelectorAll('.ff-logo-ticker__track')];
        }
        return;
      }

      const original = this.tracks[0];
      const trackWidth = original.getBoundingClientRect().width;
      if (!trackWidth) return; // not laid out yet — a later resize/load will call sync() again.

      const gap = parseFloat(getComputedStyle(this.viewport).columnGap || getComputedStyle(this.viewport).gap) || 0;
      const target = this.viewport.getBoundingClientRect().width + trackWidth;
      let total = trackWidth + clones.reduce((sum, clone) => sum + clone.getBoundingClientRect().width + gap, 0);

      while (total < target) {
        const clone = original.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-ff-lt-clone', '');
        this.viewport.appendChild(clone);
        total += trackWidth + gap;
      }
      this.tracks = [...this.querySelectorAll('.ff-logo-ticker__track')];
    }
  }

  if (!customElements.get('ff-logo-ticker')) customElements.define('ff-logo-ticker', FFLogoTicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-overlay"] && !Shopify.designMode) return;
  try {
    
  class FFOverlay extends HTMLElement {
    connectedCallback() {
      this.fitTags();
      this.bindIndicator();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.fitTags());
      window.addEventListener('resize', () => {
        clearTimeout(this.t);
        this.t = setTimeout(() => { this.fitTags(); this.syncIndicator(); }, 120);
      });
    }

    bindIndicator() {
      this.row = this.querySelector('[data-ff-ov-row]');
      this.thumb = this.querySelector('[data-ff-ov-thumb]');
      this.indicator = this.querySelector('[data-ff-ov-indicator]');
      if (!this.row || !this.thumb) return;
      this.row.addEventListener('scroll', () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => { this.raf = null; this.syncIndicator(); });
      }, { passive: true });
      if (window.ResizeObserver) new ResizeObserver(() => this.syncIndicator()).observe(this.row);
      this.syncIndicator();
    }

    syncIndicator() {
      if (!this.row || !this.thumb || !this.indicator) return;
      const track = this.indicator.clientWidth;
      const view = this.row.clientWidth;
      const content = this.row.scrollWidth;
      const scrollable = content - view;
      const fraction = content > 0 ? Math.min(1, view / content) : 1;
      const w = Math.max(0, Math.round(track * fraction));
      const progress = scrollable > 0 ? Math.min(1, Math.max(0, this.row.scrollLeft / scrollable)) : 0;
      this.thumb.style.width = w + 'px';
      this.thumb.style.transform = 'translateX(' + Math.round((track - w) * progress) + 'px)';
    }

    fitTags() {
      const reserve = parseFloat(getComputedStyle(this).getPropertyValue('--ff-ov-tag-reserve')) || 0;
      this.querySelectorAll('.ff-section-tag').forEach((tag) => {
        tag.style.marginBlock = '0px';
        const target = reserve || tag.getBoundingClientRect().height;
        const rise = (target - tag.offsetHeight) / 2;
        tag.style.marginBlock = rise > 0.01 ? `${rise.toFixed(2)}px` : '0px';
      });
    }
  }

  if (!customElements.get('ff-overlay')) customElements.define('ff-overlay', FFOverlay);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-product-page"] && !Shopify.designMode) return;
  try {
    
  class FFProductPage extends HTMLElement {
    connectedCallback() {
      this.addEventListener('ff:plp:add-to-subscription', (event) => this.handleAdd(event));
      this.watchReviews();
      this.syncBoxState();
    }

    static friendly(message) {
      const error = new Error(message);
      error.ffFriendly = true;
      return error;
    }

    messageFor(error) {
      if (error?.ffFriendly && error.message) return error.message;
      return 'We could not update your box right now. Please try again.';
    }

    async loadBox() {
      if (!this.rechargeAuth) {
        const ready = await this.ensureRecharge();
        if (!ready) throw FFProductPage.friendly('The subscription service is unavailable right now.');

        await window.recharge.init({
          storeIdentifier: this.dataset.shopDomain,
          storefrontAccessToken: this.dataset.storefrontAccessToken,
          appName: 'Product page',
          appVersion: '1.0.0',
        });

        // This store is on New Customer Accounts, which never sets the classic session
        // loginShopifyAppProxy() needs -- see snippets/ff-account-auth.liquid for why.
        if (!(await window.ffWaitForAccountAuth())) throw FFProductPage.friendly('The subscription service is unavailable right now.');
        await window.FFAccountAuth.bootstrap();
        const auth = await window.FFAccountAuth.loginToRecharge();
        if (!auth?.customerId) throw FFProductPage.friendly('We could not confirm your subscription.');
        this.rechargeAuth = auth;
      }

      if (!this.boxSubscription) {
        const { subscriptions } = await window.recharge.subscription.listSubscriptions(this.rechargeAuth, {
          customer_id: this.rechargeAuth.customerId,
          status: 'active',
        });
        this.boxSubscription = (subscriptions || []).find(
          (sub) => String(sub.external_product_id?.ecommerce) === String(this.dataset.boxProductId)
        );
      }
      if (!this.boxSubscription) throw FFProductPage.friendly('We could not find your box subscription.');

      if (!this.boxItems) {
        const { bundle_selections } = await window.recharge.bundle.listBundleSelections(this.rechargeAuth, {
          purchase_item_ids: String(this.boxSubscription.id),
        });
        this.bundleSelectionId = bundle_selections?.[0]?.id;
        this.boxItems = bundle_selections?.[0]?.items || [];
      }
      return this.boxItems;
    }

    async syncBoxState() {
      if (!this.hasAttribute('data-plp-subscription-write')) return;
      try {
        await this.loadBox();
        await this.applyBoxState();
      } catch (error) {
        console.error('[product-page] could not sync box state', error);
      }
    }

    async applyBoxState() {
      if (!this.boxItems || !this.boxItems.length) return;

      if (window.customElements && !customElements.get('ff-product-card')) {
        await Promise.race([
          customElements.whenDefined('ff-product-card'),
          new Promise((resolve) => setTimeout(resolve, 5000)),
        ]);
      }

      for (const item of this.boxItems) {
        const variantId = String(item.external_variant_id?.ecommerce ?? item.external_variant_id ?? '');
        if (!variantId) continue;

        let input = null;
        try {
          input = this.querySelector(`input[name="id"][value="${CSS.escape(variantId)}"]`);
        } catch (error) {
          continue;
        }
        if (!input) continue;

        input.dataset.inCart = String(item.quantity || 0);
        const card = input.closest('ff-product-card');
        const isActiveInput = input.type === 'radio' ? input.checked : true;
        if (card && isActiveInput && typeof card.render === 'function') card.render();
      }
    }

    watchReviews() {
      const row = this.querySelector('[data-ff-reviews-row]');
      const snippet = this.querySelector('.ruk_rating_snippet');
      if (!row || !snippet) return;

      const painted = () =>
        snippet.textContent.trim() !== '' || !!snippet.querySelector('img, svg, [class*="ruk"]');

      const reveal = () => {
        const has = painted();
        row.toggleAttribute('hidden', !has);
        return has;
      };

      if (reveal()) return;
      const observer = new MutationObserver(() => {
        if (reveal()) observer.disconnect();
      });
      observer.observe(snippet, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 15000);
    }

    async ensureRecharge(timeoutMs = 8000) {
      if (window.recharge && window.recharge.subscription) return true;

      if (!document.querySelector('[data-ff-recharge-sdk]')) {
        const script = document.createElement('script');
        script.src = `https://static.rechargecdn.com/assets/storefront/recharge-client-${this.dataset.sdkVersion}.min.js`;
        script.setAttribute('data-ff-recharge-sdk', '');
        document.head.appendChild(script);
      }

      const start = Date.now();
      while (!(window.recharge && window.recharge.subscription)) {
        if (Date.now() - start > timeoutMs) return false;
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      return true;
    }

    async ensureCollectionRules() {
      if (this.collectionRules) return this.collectionRules;
      const bundleData = await window.recharge.bundleData.loadBundleData(this.dataset.boxProductId);
      this.collectionRules = bundleData?.variants?.[0]?.collections || [];
      return this.collectionRules;
    }

    resolveCollectionId(candidateIds) {
      const withRule = candidateIds.find((id) => this.collectionRules?.some((rule) => String(rule.id) === id));
      return withRule || candidateIds[0] || null;
    }

    async handleAdd(event) {
      const { variantId, quantity, productId, onSuccess, onError } = event.detail;
      const resolvedProductId = productId || this.dataset.productId;

      try {
        if (!this.rechargeAuth) {
          const ready = await this.ensureRecharge();
          if (!ready) throw new Error('The subscription service is unavailable right now.');

          await window.recharge.init({
            storeIdentifier: this.dataset.shopDomain,
            storefrontAccessToken: this.dataset.storefrontAccessToken,
            appName: 'Product page',
            appVersion: '1.0.0',
          });

          // This store is on New Customer Accounts, which never sets the classic session
          // loginShopifyAppProxy() needs -- see snippets/ff-account-auth.liquid for why.
          if (!(await window.ffWaitForAccountAuth())) throw new Error('The subscription service is unavailable right now.');
          await window.FFAccountAuth.bootstrap();
          const auth = await window.FFAccountAuth.loginToRecharge();
          if (!auth?.customerId) throw new Error('We could not confirm your subscription.');
          this.rechargeAuth = auth;
        }

        if (!this.boxSubscription) {
          const { subscriptions } = await window.recharge.subscription.listSubscriptions(this.rechargeAuth, {
            customer_id: this.rechargeAuth.customerId,
            status: 'active',
          });
          this.boxSubscription = (subscriptions || []).find(
            (sub) => String(sub.external_product_id?.ecommerce) === String(this.dataset.boxProductId)
          );
        }
        if (!this.boxSubscription) throw new Error('We could not find your box subscription.');

        await this.ensureCollectionRules();
        const collectionId = this.resolveCollectionId((this.dataset.collectionIds || '').split(',').filter(Boolean));

        if (!this.boxItems) {
          const { bundle_selections } = await window.recharge.bundle.listBundleSelections(this.rechargeAuth, {
            purchase_item_ids: String(this.boxSubscription.id),
          });
          this.bundleSelectionId = bundle_selections?.[0]?.id;
          this.boxItems = bundle_selections?.[0]?.items || [];
        }

        const existing = this.boxItems.find((item) => String(item.external_variant_id) === String(variantId));
        if (existing) {
          existing.quantity += quantity;
        } else {
          this.boxItems.push({
            collection_id: collectionId,
            collection_source: 'shopify',
            external_product_id: resolvedProductId,
            external_variant_id: variantId,
            quantity,
          });
        }

        const payload = {
          purchase_item_id: this.boxSubscription.id,
          items: this.boxItems.map((item) => ({
            collection_id: item.collection_id,
            collection_source: item.collection_source || 'shopify',
            external_product_id: item.external_product_id,
            external_variant_id: item.external_variant_id,
            quantity: item.quantity,
          })),
        };
        const planId = await window.FFAccountAuth?.getRechargePlanId?.(this.boxSubscription, this.dataset.boxProductId);
        if (planId) payload.plan_id = planId;

        if (this.bundleSelectionId) {
          await window.recharge.bundle.updateBundleSelection(this.rechargeAuth, this.bundleSelectionId, payload);
        } else {
          const created = await window.recharge.bundle.createBundleSelection(this.rechargeAuth, payload);
          this.bundleSelectionId = created?.bundle_selection?.id || created?.id;
        }

        onSuccess?.();
      } catch (error) {
        console.error('[product-page] add to subscription failed', error);
        // Was error?.message directly -- messageFor() exists specifically to stop a raw SDK
        // error reaching the customer verbatim unless it was explicitly marked safe to show
        // (error.ffFriendly), same pattern blocks/ff-plp.liquid already calls correctly.
        // Defined here but never called, so this file was the one place doing what the
        // helper was built to prevent.
        onError?.(this.messageFor(error));
      }
    }
  }

  if (!customElements.get('ff-product-page')) customElements.define('ff-product-page', FFProductPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-review-slider"] && !Shopify.designMode) return;
  try {
    
  const FF_RS_ENDPOINTS = [
    { name: 'merchant', url: 'https://api.reviews.io/merchant/latest?store=' },
    { name: 'timeline', url: 'https://api.reviews.io/timeline/data?store=' },
  ];

  class FFReviewSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-ff-rs-track]');
      if (!this.track) return;

      this.template = this.querySelector('[data-ff-rs-template]');
      this.summary = this.querySelector('[data-ff-rs-summary]');
      this.empty = this.querySelector('[data-ff-rs-empty]');
      this.arrows = this.querySelector('[data-ff-rs-arrows]');
      this.prev = [...this.querySelectorAll('.ff-review-slider__arrow--prev')];
      this.next = [...this.querySelectorAll('.ff-review-slider__arrow--next')];

      this.prev.forEach((b) => b.addEventListener('click', () => this.step(-1)));
      this.next.forEach((b) => b.addEventListener('click', () => this.step(1)));

      this.update = this.update.bind(this);
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(this.update, 80);
      });

      if (typeof ResizeObserver === 'function') {
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
      } else {
        window.addEventListener('resize', () => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(this.update, 120);
        });
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.update);

      this.update();
      this.load();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      clearTimeout(this.timer);
      clearTimeout(this.resizeTimer);
    }

    get storeId() {
      const id = window.__REVIEWSIO_RATING_SNIPPET_STORE_OVERRIDE__ || window.reviewsIoStore;
      return typeof id === 'string' ? id.trim() : '';
    }

    get stride() {
      const items = this.track.children;
      if (!items.length) return 0;
      const second = items[1];
      return second ? second.offsetLeft - items[0].offsetLeft : items[0].offsetWidth;
    }

    step(direction) {
      this.track.scrollBy({ left: this.stride * direction });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      const scrollable = max > 1;
      const atStart = x <= 1;
      const atEnd = x >= max - 1;
      this.prev.forEach((b) => { b.disabled = !scrollable || atStart; });
      this.next.forEach((b) => { b.disabled = !scrollable || atEnd; });
    }

    cacheKey(endpoint, store) {
      return ['ff-rs', endpoint, store, this.dataset.maxReviews, this.dataset.minRating, this.dataset.minLength].join(':');
    }

    readCache(key) {
      const minutes = parseInt(this.dataset.cacheMinutes, 10);
      if (!minutes) return null;
      try {
        const raw = sessionStorage.getItem(key);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (Date.now() - parsed.at > minutes * 60000) return null;
        return parsed.data;
      } catch (e) {
        return null;
      }
    }

    writeCache(key, data) {
      if (!parseInt(this.dataset.cacheMinutes, 10)) return;
      try {
        sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), data: data }));
      } catch (e) {
      }
    }

    setState(state) {
      this.dataset.reviewsioState = state;
    }

    async fetchJson(url) {
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.json();
    }

    async load() {
      const store = this.storeId;
      if (!store) {
        this.setState('no-store-id');
        return;
      }
      if (!this.template) {
        this.setState('no-template');
        return;
      }

      let summaryApplied = false;
      let anyFailed = false;

      for (const endpoint of FF_RS_ENDPOINTS) {
        let payload = this.readCache(this.cacheKey(endpoint.name, store));

        if (!payload) {
          try {
            payload = await this.fetchJson(endpoint.url + encodeURIComponent(store));
          } catch (e) {
            anyFailed = true;
            continue;
          }
          this.writeCache(this.cacheKey(endpoint.name, store), payload);
        }

        if (!summaryApplied) summaryApplied = this.renderSummary(payload);

        const reviews = this.normalise(endpoint.name, payload);
        if (reviews.length) {
          this.render(reviews);
          this.setState('live:' + endpoint.name);
          return;
        }
      }

      if (anyFailed) this.setState(this.seededCount ? 'fetch-failed-showing-blocks' : 'fetch-failed');
      else this.setState(this.seededCount ? 'empty-showing-blocks' : 'empty');
    }

    get seededCount() {
      return parseInt(this.dataset.seededReviews, 10) || 0;
    }

    normalise(endpoint, payload) {
      let rows = [];

      if (endpoint === 'merchant') {
        rows = (payload && Array.isArray(payload.reviews) ? payload.reviews : []).map((r) => {
          const reviewer = r.reviewer || {};
          return {
            rating: Number(r.rating),
            title: (r.title || '').trim(),
            text: (r.comments || '').trim(),
            name: [reviewer.first_name, reviewer.last_name].map((p) => (p || '').trim()).filter(Boolean).join(' '),
            verified: String(reviewer.verified_buyer).toLowerCase() === 'yes',
          };
        });
      } else if (endpoint === 'timeline') {
        rows = (payload && Array.isArray(payload.timeline) ? payload.timeline : []).map((entry) => {
          const r = (entry && entry._source) || {};
          return {
            rating: Number(r.rating),
            title: (r.title || '').trim(),
            text: (r.comments || '').trim(),
            name: (r.author || '').trim(),
            verified: /verified/i.test(r.reviewer_desc || '') || r.verified_by === 'author',
          };
        });
      }

      const minRating = parseFloat(this.dataset.minRating) || 0;
      const minLength = parseInt(this.dataset.minLength, 10) || 0;
      const max = parseInt(this.dataset.maxReviews, 10) || 12;

      return rows
        .filter((r) => isFinite(r.rating) && r.rating >= minRating)
        .filter((r) => r.text.length >= minLength)
        .slice(0, max);
    }

    render(reviews) {
      const fragment = document.createDocumentFragment();

      reviews.forEach((review) => {
        const node = this.template.content.cloneNode(true);
        const rating = Math.max(0, Math.min(5, review.rating || 0));

        const stars = node.querySelector('[data-ff-rs-stars]');
        if (stars) stars.style.setProperty('--ff-rs-fill', (rating / 5) * 100 + '%');
        const starsSr = node.querySelector('[data-ff-rs-stars-sr]');
        if (starsSr) starsSr.textContent = rating + ' out of 5';

        const title = node.querySelector('[data-ff-rs-title]');
        if (title) {
          if (review.title) title.textContent = review.title;
          else title.remove();
        }

        const text = node.querySelector('[data-ff-rs-text]');
        if (text) text.textContent = review.text;

        const nameEl = node.querySelector('[data-ff-rs-name]');
        const reviewerEl = node.querySelector('[data-ff-rs-reviewer]');
        if (review.name && nameEl) nameEl.textContent = review.name;
        else if (reviewerEl) reviewerEl.remove();

        const badge = node.querySelector('[data-ff-rs-badge]');
        if (badge && !review.verified) badge.remove();

        fragment.appendChild(node);
      });

      this.track.replaceChildren(fragment);
      this.track.hidden = false;
      if (this.empty) this.empty.hidden = true;
      if (this.arrows) this.arrows.hidden = false;
      this.track.scrollLeft = 0;
      this.update();
    }

    renderSummary(payload) {
      if (this.dataset.showSummary !== 'true' || !this.summary) return false;

      const stats = (payload && (payload.stats || payload.storeStats)) || {};
      const average = parseFloat(stats.average_rating);
      const count = parseInt(stats.total_reviews != null ? stats.total_reviews : stats.review_count, 10);
      if (!isFinite(average) || average <= 0 || !(count > 0)) return false;

      const rounded = average.toFixed(1);

      const score = this.querySelector('[data-ff-rs-score]');
      if (score) score.textContent = rounded;

      const word = this.querySelector('[data-ff-rs-word]');
      if (word && payload.word) word.textContent = payload.word;

      const stars = this.querySelector('[data-ff-rs-summary-stars]');
      if (stars) stars.style.setProperty('--ff-rs-fill', (average / 5) * 100 + '%');

      const sr = this.querySelector('[data-ff-rs-summary-sr]');
      if (sr) sr.textContent = rounded + ' out of 5';

      this.summary.hidden = false;
      this.summary.dataset.ratingSource = 'reviewsio';
      return true;
    }
  }

  if (!customElements.get('ff-review-slider')) customElements.define('ff-review-slider', FFReviewSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-three-column"] && !Shopify.designMode) return;
  try {
    
  class FFThreeColumn extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-ff-tc-track]');
      if (!this.track) return;
      this.items = [...this.track.children];

      this.fitTags();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.fitTags());

      this.querySelectorAll('[data-ff-tc-prev]').forEach((b) => b.addEventListener('click', () => this.step(-1)));
      this.querySelectorAll('[data-ff-tc-next]').forEach((b) => b.addEventListener('click', () => this.step(1)));

      this.update = this.update.bind(this);
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(this.update, 80);
      });
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          this.fitTags();
          this.update();
        }, 120);
      });
      this.update();
    }

    fitTags() {
      this.querySelectorAll('.ff-section-tag').forEach((tag) => {
        tag.style.marginBlock = '0px';
        const layout = tag.offsetHeight;
        const visual = tag.getBoundingClientRect().height;
        const rise = (visual - layout) / 2;
        if (rise > 0.01) tag.style.marginBlock = `${rise.toFixed(2)}px`;
      });
    }

    get stride() {
      const first = this.items[0];
      if (!first) return 0;
      const second = this.items[1];
      return second ? second.offsetLeft - first.offsetLeft : first.offsetWidth;
    }

    step(direction) {
      this.track.scrollBy({ left: this.stride * direction });
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      this.querySelectorAll('[data-ff-tc-prev]').forEach((b) => {
        b.disabled = x <= 1;
      });
      this.querySelectorAll('[data-ff-tc-next]').forEach((b) => {
        b.disabled = x >= max - 1;
      });
    }
  }

  if (!customElements.get('ff-three-column')) customElements.define('ff-three-column', FFThreeColumn);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-ticker"] && !Shopify.designMode) return;
  try {
    
  class FFTicker extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.ff-ticker__viewport');
      this.tracks = [...this.querySelectorAll('.ff-ticker__track')];
      if (!this.viewport || !this.tracks.length) return;

      this.mq = window.matchMedia('(max-width: 989px)');
      this.sync = this.sync.bind(this);
      this.sync();
      this.mq.addEventListener('change', this.sync);
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.sync);
        this.ro.observe(this.viewport);
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.sync);
    }

    disconnectedCallback() {
      this.mq?.removeEventListener('change', this.sync);
      this.ro?.disconnect();
    }

    get scrolling() {
      return this.classList.contains('ff-ticker--marquee') || this.mq.matches;
    }

    sync() {
      if (!this.scrolling) {
        this.style.removeProperty('--ff-tk-duration');
        this.ensureClone(false);
        return;
      }
      this.ensureClone(true);
      const width = this.tracks[0].scrollWidth;
      const speed = Math.max(10, Number(this.dataset.speed) || 60);
      this.style.setProperty('--ff-tk-duration', `${(width / speed).toFixed(2)}s`);
    }

    ensureClone(wanted) {
      const existing = this.viewport.querySelector('[data-ff-tk-clone]');
      if (wanted && !existing && this.tracks.length === 1) {
        const clone = this.tracks[0].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-ff-tk-clone', '');
        this.viewport.appendChild(clone);
        this.tracks = [...this.querySelectorAll('.ff-ticker__track')];
      } else if (!wanted && existing) {
        existing.remove();
        this.tracks = [...this.querySelectorAll('.ff-ticker__track')];
      }
    }
  }

  if (!customElements.get('ff-ticker')) customElements.define('ff-ticker', FFTicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-video-slider"] && !Shopify.designMode) return;
  try {
    
  class FFVideoSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-ff-vs-track]');
      if (!this.track) return;
      this.items = [...this.track.children];

      this.querySelectorAll('.ff-video-slider__arrow--prev').forEach((b) => b.addEventListener('click', () => this.step(-1)));
      this.querySelectorAll('.ff-video-slider__arrow--next').forEach((b) => b.addEventListener('click', () => this.step(1)));
      this.addEventListener('click', (e) => {
        const button = e.target.closest && e.target.closest('[data-ff-vs-play]');
        if (button && this.contains(button)) this.play(button);
      });

      this.update = this.update.bind(this);
      this.settle = this.settle.bind(this);
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.raf);
        this.raf = setTimeout(this.settle, 80);
      }, { passive: true });
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => { this.measureLoop(); this.normalise(); this.update(); });
        this.ro.observe(this);
      }
      this.setupLoop();
      this.update();
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
    }

    get stride() {
      const first = this.items[0];
      if (!first) return 0;
      const second = this.items[1];
      return second ? second.offsetLeft - first.offsetLeft : first.offsetWidth;
    }

    step(direction) {
      this.track.scrollBy({ left: this.stride * direction });
    }

    setupLoop() {
      if (this.looping) return;
      const originals = [...this.track.children].filter((el) => !el.hasAttribute('data-ff-clone'));
      if (originals.length < 2) return;
      if (this.track.scrollWidth <= this.track.clientWidth + 1) return;

      this.originalCount = originals.length;
      for (let copy = 0; copy < 2; copy += 1) {
        const fragment = document.createDocumentFragment();
        originals.forEach((el) => {
          const clone = el.cloneNode(true);
          clone.setAttribute('data-ff-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((f) => {
            f.setAttribute('tabindex', '-1');
          });
          fragment.appendChild(clone);
        });
        this.track.appendChild(fragment);
      }

      this.items = [...this.track.children];
      this.looping = true;
      this.setAttribute('data-ff-looping', '');
      this.measureLoop();
      if (this.setWidth) this.jump(this.setWidth);
    }

    measureLoop() {
      if (!this.looping) return;
      const items = this.track.children;
      const first = items[0];
      const firstClone = items[this.originalCount];
      if (!first || !firstClone) return;
      this.setWidth = firstClone.offsetLeft - first.offsetLeft;
    }

    jump(to) {
      const previous = this.track.style.scrollBehavior;
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft = to;
      this.track.style.scrollBehavior = previous;
    }

    settle() {
      this.normalise();
      this.update();
    }

    normalise() {
      if (!this.looping || !this.setWidth) return;
      const L = this.setWidth;
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (max <= L) return;
      const x = this.track.scrollLeft;
      let target = x + Math.round((max / 2 - x) / L) * L;
      while (target < 0) target += L;
      while (target > max) target -= L;
      if (Math.abs(target - x) > 0.5) this.jump(target);
    }

    update() {
      if (this.looping) {
        this.querySelectorAll('.ff-video-slider__arrow--prev').forEach((b) => { b.disabled = false; });
        this.querySelectorAll('.ff-video-slider__arrow--next').forEach((b) => { b.disabled = false; });
        return;
      }
      const max = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      this.querySelectorAll('.ff-video-slider__arrow--prev').forEach((b) => { b.disabled = x <= 1; });
      this.querySelectorAll('.ff-video-slider__arrow--next').forEach((b) => { b.disabled = x >= max - 1; });
    }

    play(button) {
      const media = button.closest('[data-ff-vs-media]');
      const template = media?.querySelector('[data-ff-vs-player]');
      if (!template) return;

      const fragment = template.content.cloneNode(true);
      const pending = fragment.querySelector('video');
      if (pending) {
        pending.preload = 'auto';
        pending.setAttribute('playsinline', '');
      }
      media.appendChild(fragment);
      media.setAttribute('data-playing', '');

      const video = media.querySelector('video');
      if (video) {
        try { video.load(); } catch (e) {}
        const started = video.play?.();
        if (started && typeof started.catch === 'function') {
          started.catch(() => {
            video.muted = true;
            video.play?.().catch(() => {});
          });
        }
      }
      button.remove();
    }
  }

  if (!customElements.get('ff-video-slider')) customElements.define('ff-video-slider', FFVideoSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
